import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Portal', icon: FAVICONS.default}),
    routes: [
        {
            path: '/portal/:ahId(\\d+)/',
            component: () => import(/* webpackChunkName: "ahPortal" */ './AhPage.vue'),
            props: true,
            children: [
                {
                    name: 'ah-members-list',
                    props: true,
                    path: '',
                    component: () => import(/* webpackChunkName: "ahPortal" */ './members/MembersListPage.vue')
                },
                {
                    name: 'ah-user-permissions-list',
                    props: true,
                    path: 'templates/user-permissions/',
                    component: () => import(/* webpackChunkName: "ahPortal" */ './permission_templates/UserPermissionsTemplatePage.vue')
                },
                {
                    name: 'ah-user-permissions-detail',
                    props: true,
                    path: 'templates/user-permissions/:templateId(\\d+)/',
                    component: () => import(/* webpackChunkName: "ahPortal" */ './permission_templates/UserPermissionTemplateDetailPage.vue')
                },
                {
                    name: 'member-list-diaries',
                    path: 'lists/diaries/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/DiariesListPage.vue')
                },
                {
                    name: 'member-list-goals',
                    path: 'lists/goals/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/GoalsListPage.vue')
                },
                {
                    name: 'member-list-wikis',
                    path: 'lists/wikis/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/WikisListPage.vue')
                },
                {
                    name: 'member-circle-members',
                    path: 'lists/circle-members/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/CircleMembersListPage.vue')
                },
                {
                    name: 'member-circle-groups',
                    path: 'lists/circle-groups/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/CircleGroupsListPage.vue')
                },
                {
                    name: 'communities-and-groups',
                    path: 'lists/communities-and-groups/:memberId(\\d+)/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './member_lists/CommunitiesAndGroupsListPage.vue')
                },
                {
                    name: 'manage-goals-and-categories',
                    path: 'manage/goals-and-categories/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/ManageGoalsCategories.vue')
                },
                {
                    name: 'manage-goals-assistance',
                    path: 'manage/goals-assistance/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/ManageGoalAssistancePage.vue')
                },
                {
                    name: 'manage-communities-and-groups',
                    path: 'manage/communities-and-groups/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/ManageCommunitiesAndGroups.vue')
                },
                {
                    name: 'manage-buddy-groups',
                    path: 'manage/buddy-groups/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/buddy_groups/ManageBuddyGroupsPage.vue')
                },
                {
                    name: 'manage-wiki-templates',
                    path: 'manage/wiki-templates/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/wiki_templates/ManageWikiTemplatesPage.vue')
                },
                {
                    name: 'manage-invite-template',
                    path: 'manage/invite-template/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/ManageCircleInviteTemplate.vue')
                },
                {
                    name: 'assign-goal-categories',
                    path: 'assign/goal-categories/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/AssignGoalCategories.vue')
                },
                {
                    name: 'manage-roles',
                    path: 'manage/roles/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/ManageRolesPage.vue')
                },
                {
                    name: 'bind-roles',
                    path: 'manage/bind-roles/',
                    props: true,
                    component: () => import(/* webpackChunkName: "ahPortal" */ './manage/BindRolesPage.vue')
                },
            ]
        },
    ]
});
